export enum PageKey {
  HOME = 'home',
  LOGIN = 'login',
  USERS = 'users',
  CRUD = 'crud_users',
  COURSES = 'courses',
  TRACKS = 'tracks'
}
